import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Anchor from '../Anchor'
import Spinner from 'components/Spinner'
import styles from './baseButton-style.css'

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  containerElement: PropTypes.node,
  href: PropTypes.string,
  primary: PropTypes.bool,
  flat: PropTypes.bool,
  transparent: PropTypes.bool,
  fullwidth: PropTypes.bool,
  expands: PropTypes.bool,
  small: PropTypes.bool,
  icon: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  alignLeft: PropTypes.bool,
  label: PropTypes.string,
  loading: PropTypes.bool,
  color: PropTypes.oneOf(['primary']),
}

const defaultProps = {
  containerElement: 'button',
}

/**
 * Base component that should be used on Button components.
 * Configure the correct usability styling of a button here,
 * render Anchor or button according to content.
 */
function BaseButton({
  className,
  containerElement,
  children,
  href,
  primary,
  flat,
  transparent,
  small,
  icon,
  width,
  height,
  fullwidth,
  expands,
  label,
  scrollTo,
  onClick,
  disabled,
  type,
  secondary,
  alignLeft,
  loading,
  underlineOnHover,
  ...rest
}) {
  const isAnchor = href !== undefined
  const buttonProps = {
    className: cx(styles.baseButton, className, 'vFact_DoNotReadAloud', {
      [styles.primary]: !flat && primary,
      [styles.flat]: flat,
      [styles.transparent]: transparent,
      [styles.small]: small,
      [styles.withIcon]: icon,
      [styles.fullWidth]: fullwidth,
      [styles.expands]: expands,
      [styles.disabled]: disabled,
      [styles.reverse]: icon === 'back' || icon === 'follow',
      [styles.secondary]: secondary,
      [styles.alignLeft]: alignLeft,
      [styles.loading]: loading,
      [styles.underline]: underlineOnHover,
    }),
    type: !isAnchor ? type || 'button' : undefined,
    href,
    role: primary || secondary || transparent ? 'button' : null,
    disabled,
    onClick: scrollTo
      ? () => {
          const item = document.querySelector(scrollTo)
          if (item)
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            })
        }
      : onClick,
    ...rest,
  }

  const iconSvg = icon && require(`../../icons/${icon}Icon.js`).default

  return icon
    ? React.createElement(
        'div',
        {
          style: {
            display: fullwidth || expands ? 'block' : 'inline-block',
          },
          className: styles.iconWrapper,
        },
        React.createElement(
          isAnchor ? Anchor : containerElement,
          buttonProps,
          React.createElement('span', {}, children || label),
          React.createElement(
            'i',
            {
              style: {
                display: 'inline-block',
              },
            },
            iconSvg(),
          ),
        ),
      )
    : React.createElement(
        isAnchor ? Anchor : containerElement,
        buttonProps,
        React.createElement(
          'span',
          {},

          children || label,
        ),
        loading &&
          React.createElement(Spinner, { color: 'white', size: 'small' }),
      )
}

BaseButton.displayName = 'BaseButton'
BaseButton.propTypes = propTypes
BaseButton.defaultProps = defaultProps

export default BaseButton



// WEBPACK FOOTER //
// ./src/components/BaseButton/BaseButton.js